export const GET_EVENT_DATA = 'GET_EVENT_DATA';
export const GET_EVENT_DATA_ERROR = 'GET_EVENT_DATA_ERROR';
export const SET_EVENT_LAST_UPDATE = 'SET_EVENT_LAST_UPDATE';
export const RELOAD_EVENT_STATE = 'RELOAD_EVENT_STATE';